export type BookingCompleted = Readonly<{
    type: "booking:completed"
    startUtc: string
    endUtc: string
    meetingLocation: string
    // orderId: number
}>
export type BookingCancelled = Readonly<{ type: "booking:cancelled"; reason?: string }>
export type BookingFailed = Readonly<{ type: "booking:failed"; reason?: string }>
export type DialogClose = { type: "dialog:close"; reason?: string }

export type BookingResultMessage = BookingCompleted | BookingCancelled | BookingFailed | DialogClose

export async function postBookingResultToOutlook(msg: BookingResultMessage, parentOrigin: string) {
    await Office.onReady()
    const json = JSON.stringify(msg)
    Office.context.ui.messageParent(json, { targetOrigin: parentOrigin })
}
